export default function Home() {
    return (
        <div>

            <header id="home" className="hero">
                <div className="hero-content">
                    <h1>Reid Sojka</h1>
                    <p>Sailor</p>
                </div>
            </header>

            <section id="about">
                <h2>About Me</h2>
                <p>
                    Hi, I'm Reid. I grew up sailing out of Encinal Yacht Club, starting in Optis and moving up through c420s
                    and ILCAs. I'm also the Co-Captain of the Alameda High Sailing Team where we compete in FJs in the PCISA
                    district.
                </p>
            </section>

            <section id="upcoming">
                <h2>Upcoming Events</h2>
                <ul className="upcoming-events">
                    <li>Rosebowl PCISA - January 3-4, Long Beach</li>
                    <li>C420 Midwinters - Febuary 14-16, US Sailing Center Marin County, FL</li>
                </ul>
            </section>

            <section id="resume">
                <h2>Top Results</h2>
                <div className="timeline">
                    <div className="entry">
                        <h3>2025 US Youth Champs - ILCA 6</h3>
                        <p>
                            34th at the 2025 US Youth Championship. I was very lucky to be invited to compete in the very
                            competitive ILCA 6 fleet. A total of 64 boats were invited for this three day regatta at 
                            Lauderdale Yacht Club.
                        </p>
                        <a href="https://theclubspot.com/regatta/ClM7E0PnQZ/" target="_blank">Results</a>
                    </div>
                    <div className="entry">
                        <h3>2025 NorCal High School Champs</h3>
                        <p>
                            1st overall at divisional championship for Northern California High School
                            sailing.
                        </p>
                        <a href="https://scores.hssailing.org/s25/2025-norcal-divisional/" target="_blank">Results</a>
                    </div>
                    <div className="entry">
                        <h3>2025 PCISA Golden Bear Gold</h3>
                        <p>
                            7th in A fleet at one of the Pacific Coast championship regattas for High School Sailing
                        </p>
                        <a href="https://scores.hssailing.org/s25/2025-pcisa-golden-bear/A/" target="_blank">Results</a>
                    </div>
                    <div className="entry">
                        <h3>2025 ILCA North American Championship (ILCA 6)</h3>
                        <p>24th in Silver Fleet at ILCA North Americans in the ILCA 6. This was also my first
                            big ILCA event!
                        </p>
                        <a href="https://abyc.org/regatta/WPhMFdQzHj" target="_blank">Results</a>
                    </div>
                </div>
            </section>

            <section id="gallery">
                <h2>Gallery</h2>
                <div className="gallery-grid">
                    <img src="images/FJUpwind1.jpg" alt="Reid sailing upwind at 2025 Norcal 5/6" />
                    <img src="images/LaserUpwind.jpg" alt="Reid sailing upwind at 2025 Norcal 5/6" />
                    <img src="images/RiggingLaser.jpg" alt="Reid rigging Ilca" />
                </div>
            </section>
        </div>
    )
}